import { Constants } from '../../../constants';
import { StraxMetadataLoader } from '../strax/straxMetadataLoader';
import RetrieveMetadataLoaderAsync from './retrieveMetadataLoaderAsync';
import RetrieveMetadataLoaderSync from './retrieveMetadataLoaderSync';

/**
 * Retrieve Study metadata from a DICOM server. If the server is configured to use lazy load, only the first series
 * will be loaded and the property "studyLoader" will be set to let consumer load remaining series as needed.
 *
 * @param {Object} server Object with server configuration parameters
 * @param {string} StudyInstanceUID The Study Instance UID of the study which needs to be loaded
 * @param {Object} [filters] - Object containing filters to be applied on retrieve metadata process
 * @param {string} [filter.seriesInstanceUID] - series instance uid to filter results against
 * @param {string} [filter.zipUrl] - Source zip url from any source, must be presigned
 * @returns {Object} A study descriptor object
 */
async function RetrieveMetadata(server, StudyInstanceUID, filters = {}) {
  // - Strax: We will build metadata use custom loader
  if (server.name === Constants.straxServerNames.imageZipUrl) {
    const straxMetadataLoader = new StraxMetadataLoader(
      server.apiUrl,
      StudyInstanceUID,
      filters.zipUrl
    );
    return straxMetadataLoader.execLoad();
  }

  const RetrieveMetadataLoader =
    server.enableStudyLazyLoad != false
      ? RetrieveMetadataLoaderAsync
      : RetrieveMetadataLoaderSync;

  const retrieveMetadataLoader = new RetrieveMetadataLoader(
    server,
    StudyInstanceUID,
    filters
  );
  const studyMetadata = retrieveMetadataLoader.execLoad();

  return studyMetadata;
}

export default RetrieveMetadata;
